import {useEffect, useState} from "react"
import {cropPrintedCheckTopBand} from "../utilities/printedCheckImage"

export function usePrintedCheckCroppedLinks(frontSrc: string, backSrc: string) {
	const [links, setLinks] = useState({front: "", back: ""})
	const [isLoading, setIsLoading] = useState(false)

	useEffect(() => {
		if (!frontSrc && !backSrc) {
			setLinks({front: "", back: ""})
			setIsLoading(false)
			return
		}

		let cancelled = false
		setIsLoading(true)

		Promise.all([
			frontSrc ? cropPrintedCheckTopBand(frontSrc) : Promise.resolve(""),
			backSrc ? cropPrintedCheckTopBand(backSrc) : Promise.resolve(""),
		])
			.then(([front, back]) => {
				if (!cancelled) {
					setLinks({front, back})
					setIsLoading(false)
				}
			})
			.catch(() => {
				if (!cancelled) {
					setLinks({front: "", back: ""})
					setIsLoading(false)
				}
			})

		return () => {
			cancelled = true
		}
	}, [frontSrc, backSrc])

	return {...links, isLoading}
}
